"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowBack = function ArrowBack() {
  return _react2.default.createElement(
    "g",
    { id: "arrow-back" },
    _react2.default.createElement("polygon", {
      id: "Shape",
      points: "500 218.75 118.75 218.75 293.75 43.75 250 0 0 250 250 500 293.75 456.25 118.75 281.25 500 281.25"
    })
  );
};

exports.default = ArrowBack;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/ArrowBack.js
// module id = 2920
// module chunks = 4